import { render, staticRenderFns } from "./FinanceTable.vue?vue&type=template&id=050f8106"
import script from "./FinanceTable.vue?vue&type=script&lang=js"
export * from "./FinanceTable.vue?vue&type=script&lang=js"
import style0 from "./FinanceTable.vue?vue&type=style&index=0&id=050f8106&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports